import { render, staticRenderFns } from "./ChoiceGroup.vue?vue&type=template&id=13ead616&scoped=true&"
import script from "./ChoiceGroup.vue?vue&type=script&lang=js&"
export * from "./ChoiceGroup.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceGroup.vue?vue&type=style&index=0&id=13ead616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ead616",
  null
  
)

export default component.exports